import * as React from "react";

import { cn } from "@/newComponents/utils/utils";

import { useUIStateStore } from "../../store/uiStateStore";

export type FormNumberInputProps = { label?: string; smallFont?: boolean; min?: number; max?: number; hasError?: boolean; showPercentage?: boolean } & React.InputHTMLAttributes<HTMLInputElement>;

const FormNumberInput = React.forwardRef<HTMLInputElement, FormNumberInputProps>(
  ({ hasError, smallFont, min, max, className, showPercentage = false, ...props }, ref) => {
    const isTunecore = useUIStateStore(state => state.isTunecore);

    return (
      <div className="flex flex-col justify-between">
        <label
          className={cn(
            "leading-snug self-start",
            smallFont ? "text-xs" : "text-base",
            isTunecore ? "font-tunecore" : "font-sentric-alt",
          )}
          htmlFor="formNumberInput"
        >
          {props.label}
        </label>
        <div className="relative">
          <input
            min={min}
            max={max}
            id="formNumberInput"
            name="formNumberInput"
            type="number"
            className={cn(
              "flex font-medium rounded-lg px-2 py-1.5 min-w-24 focus-visible:outline-none transition ease-in-out duration-200",
              showPercentage ? "pr-6" : "", // Add right padding when percentage is shown
              smallFont ? "text-xs" : "text-sm",
              isTunecore
                ? "font-tunecore bg-tunecore-light-grey placeholder:text-white placeholder:text-opacity-35 ring-1 hover:ring-2 ring-tunecore-light-grey hover:ring-tunecore-green focus-visible:ring-tunecore-green"
                : "font-sentric-alt placeholder:text-black placeholder:text-opacity-85 ring-1 hover:ring-2 ring-sentric-dark-background hover:ring-sentric-orange focus-visible:ring-2 focus-visible:ring-sentric-orange",
              hasError && (isTunecore ? "ring-red-500" : "ring-red-500 bg-red-500"),
              className,
            )}
            ref={ref}
            {...props}
          />
          {showPercentage && (
            <span
              className={cn(
                "absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none",
                smallFont ? "text-xs" : "text-sm",
                isTunecore ? "font-tunecore text-white" : "font-sentric-alt text-black",
              )}
            >
              %
            </span>
          )}
        </div>
      </div>
    );
  },
);
FormNumberInput.displayName = "NumberInput";

export { FormNumberInput };

// disabled:cursor-not-allowed disabled:opacity-50
